import { CoreApiResponse } from "../../libs/core-api-requests/common";
import KizDocRequest from "../../libs/core-api-requests/dirs/kizDocRequest";
import { IKizDocBatchDisposalRequest, IKizDocBatchDisposalResult, IKizDocEditDto, IKizDocRefusalDto, IkizDocumentItemGtinDto, IKizDTO, IKizViewDTO } from "../../libs/coreapi-dto/dirs/kiz";
import CoreApiService from "../../system/api/coreApiService";
import renderGlobalAlert from "../../system/hooks/useGlobalAlert";
import { DictionaryDataProvider } from "./Common";

export class KizDocDataProvider extends DictionaryDataProvider<IKizViewDTO, IKizDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<KizDocRequest> {
        return this._coreApiService.kizDocRequest
    }

    create702Document(idInvoiceGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.create702Document(idInvoiceGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }
    create702DocumentType3(idInvoiceGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.create702DocumentType3(idInvoiceGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }
    create521ChequeDocument(idChequeGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.create521ChequeDocument(idChequeGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }
    warningCreate702Document(idInvoiceGlobal: string, receiveType: number, callback?: (e: CoreApiResponse<number | null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.warningCreate702Document(idInvoiceGlobal, receiveType, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }
    createRepeatSendDocument(idDocumentGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.createRepeatSendDocument(idDocumentGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }
    createRepeatSendPackingInfo(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean|null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.createRepeatSendPackingInfo(idDocumentGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }

    createRepeatSendInfoGismt(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean|null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.createRepeatSendInfoGismt(idDocumentGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }

    createRepeatSendRvDisposal(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean|null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.createRepeatSendRvDisposal(idDocumentGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }

    createRepeatSend531Disposal(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean|null>) => void) {
        this.getDataRequest()
            .then(r =>
                r.createRepeatSend531Disposal(idDocumentGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e);
                    } else {
                        callback?.(e)
                    }
                })
            );
    }

    createRepeatBatchDisposal(request: IKizDocBatchDisposalRequest, callback?: (e: IKizDocBatchDisposalResult) => void, fallback?: () => void) {
        this.getDataRequest()
            .then(r =>
                r.createRepeatBatchDisposal(request, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e.data);
                    } else {
                        fallback?.()
                    }
                })
            );
    }

    GetKizDocByIdDocumentAsync (idDocumentGlobal: string, callback?: (data: IKizDocEditDto) => void, failCallback?: () => void) {
            this.getDataRequest()
                .then(r => r
                    .GetKizDocByIdDocumentAsync(idDocumentGlobal, (e) => {
                        if (e.respType === 'isCompleted') {
                            callback?.(e.data);
                        } else {
                            failCallback?.();
                            throw new Error(e.message.title);
                        }
                    })
                )
            .catch(error => {
                console.error(error)
                failCallback?.();
            });
    }

    revise(request: IKizDocEditDto, callback?: (e: boolean) => void, fallback?: () => void) {
        this.getDataRequest()
            .then(r =>
                r.revise(request, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e.data);
                    } else {
                        fallback?.()
                    }
                })
            );
    }

    createRefusalDocument(request: IKizDocRefusalDto, callback?: (result: boolean) => void, fallback?: () => void) {
        this.getDataRequest()
            .then(r =>
                r.createRefusalDocument(request, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e.data);
                    } else {
                        fallback?.()
                    }
                })
            );
    }

    sendCreateRefusalDocument = async (idDocument: string, idTable: number, reason: string, callback?: (result: any) => void, fallback?: () => void) => {

        this.createRefusalDocument({
            idDocumentGlobal: idDocument,
            idTableVariant: idTable,
            refusalReason: reason
        } as IKizDocRefusalDto, callback, fallback);
    }
}